<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/landing/logo_black.png" searchImgSrc="../../../../static/img/landing/search_black.png"></navbar>
      <div class="st-FixedPoint"></div>
      <div class="st-MainContainer">
        <main class="st-MainContents" style="padding-top:120px;">

          <!-- ▼▼▼▼▼ series navi start ▼▼▼▼▼ -->
          <nav class="series-Nav sw-stickyTrigger-target">
            <div class="series-Nav_Inner">
              <ul>
                <li class="" data-series="guzzilla">
                  <a href="/product/product-0001">
                    <p><img style="height: 50px;object-fit: cover;" src="../../../../static/img/landing/main5.png" alt=""></p>
                    <h3 class="pl-5">光学曲線研削加工</h3>
                  </a>
                </li>
                <li class="" data-series="grasper">
                  <a href="/product/product-0002">
                    <p><img style="height: 50px;object-fit: cover;" src="../../../../static/img/landing/main7.png" alt=""></p>
                    <h3 class="pl-5">精密ワイヤーカット</h3>
                  </a>
                </li>
                <li class="current" data-series="mag-gon">
                  <a href="/product/product-0003">
                    <p><img style="height: 50px;object-fit: cover;" src="../../../../static/img/landing/main6.png" alt=""></p>
                    <h3 class="pl-5">精密平面研削</h3>
                  </a>
                </li>
              </ul>
            </div>
          </nav>
          <!-- ▲▲▲▲▲ series navi end ▲▲▲▲▲ -->

          <!-- ▼▼▼▼▼ contents start ▼▼▼▼▼ -->
          <header class="series-PageTitle">
            <div class="series-PageTitle_Inner" data-appear>
              <!-- <video class="js-Scroll_Movie" src="https://www.taguchi.co.jp/wp-content/themes/taguchi/assets/mov/guzzilla_product.mp4" muted loop playsinline></video> -->
              <h1>
                <span class="series-PageTitle_Logo"><img src="../../../../static/img/landing/logo_white.png" alt=""></span>
                <span class="series-PageTitle_Title" style="color:#FFF">精密平面研削</span>
              </h1>
              <div class="sw-parallax">
                <div class="sw-parallax_outer js-parallax_outer">
                  <div class="sw-parallax_inner">
                    <div class="sw-parallax_block js-parallax_block">
                      <div class="sw-parallax_target innovation-PageTitle-visual" style="background: url(../../../../static/img/landing/main6.png) 50%/cover no-repeat;top: 70px;height: 480px;"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <section class="product-Detail">
            <div class="product-Detail_Inner">
              <p class="product-Detail_Lead appear" data-appear>
                精密平面研削<br>精密な平面研磨、主のは形状修正と平面度と光沢度の加工です、 一番ベスト光沢度はR0.05、加工精度は±0.001以下、最小溝は0.070mm、コーナン処理はR0.01、各種類の精密部品加工に保証できます。
              </p>
              <div class="product-Detail_Body">
                <div class="product-Detail_Column">
                  <div class="product-Detail_Column-image" data-appear>
                    <picture><img src="../../../../static/img/landing/main6.png" alt=""></picture>
                  </div>
                  <div class="product-Detail_Column-text-appear" data-appear>
                    <h3 class="product-Detail_Column-copy" style="color: #c7000b">PRECISION Surface Grinding</h3>
                    <p class="product-Detail_Column-text">The precision plane grinders, which are mainly  used for precision machining of shape finishing and surface parallelism and finish.The maximum finish is R0.05r the machining accuracy can be controlled within ±1μm, and ths minimum groove is 0.070 mm. The best clearance angle is R0.01, It can satisfy  all kinds of ultra-precision die parts processing.</p>
                  </div>
                </div>
                <div class="product-Detail_Column">
                  <div class="product-Detail_Column-image" data-appear>
                    <picture><img src="../../../../static/img/landing/main6.png" alt=""></picture>
                  </div>
                  <div class="product-Detail_Column-text-appear" data-appear>
                    <p class="product-Detail_Column-lead">精密平面研磨</p>
                    <h3 class="product-Detail_Column-copy">精密平面研磨</h3>
                    <p class="product-Detail_Column-text">精密平面磨床.主要用于形状精修和表面平行度及光洁度的精修加工，最高光洁度为R0.05,加工精度可控制在±1μm以内，最小沟槽为0.070mm，最佳清角为R0.01,完全可以满足各类超精密模具零件加工.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- ▲▲▲▲▲ modal block end ▲▲▲▲▲ -->
          <section class="top-News pt-0 pb-5">
            <div class="st-Grid_Inner st-Grid_Inner_appear p-0 pl-md-5">
              <h2 class="sw-Section_Header" data-appear="true">
                <span class="sw-Section_Header-en"><b>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">SHOW</font>
                    </font>
                  </b></span>
                <span class="sw-Section_Header-ja"><b>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">工場展示</font>
                    </font>
                  </b></span>
              </h2>
              <div class="st-News_Slide swiper-container-news swiper-container-initialized swiper-container-horizontal appear" data-appear="true">
                <div class="swiper-wrapper">
                  <div v-for="(item, index) in newsData" :key="index" class="swiper-slide swiper-slide-news">
                    <a :href="item.link">
                      <div class="st-News_Slide-image">
                        <div class="st-News_Slide-image-inner">
                          <div :style="{'background-image':item.imgSrc}"></div>
                        </div>
                      </div>
                      <div class="sw-Eyebrow">
                        <p class="sw-Eyebrow_Lavel" data-lavel="product">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;">{{item.lavel}}</font>
                          </font>
                        </p>
                        <p class="sw-Eyebrow_Category">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;"></font>
                          </font>
                        </p>
                        <p class="sw-Eyebrow_Date">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;">{{item.date}}</font>
                          </font>
                        </p>
                      </div>
                      <p class="st-News_Slide-title">
                        <font style="vertical-align: inherit;">
                          <font style="vertical-align: inherit;">{{item.content1}}</font>
                          <br />
                          <font style="vertical-align: inherit;">{{item.content2}}</font>
                        </font>
                      </p>
                    </a>
                  </div>
                </div>
                <div class="swiper-button-next"><i class="icf el-icon-arrow-right" style="font-size:25px;bottom: 15px;"></i></div>
                <div class="swiper-button-prev swiper-button-disabled"><i class="icf el-icon-arrow-left" style="font-size:25px;bottom: 15px;"></i></div>
                <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
              </div><!-- /.st-News_Slide -->
              <!-- <div class="sw-ButtonRound"><a style="border-bottom-style: solid;bottom: 15px;" href="/news"><span>更多</span><i class="icf el-icon-plus" style="font-size:25px;bottom: 15px;"></i></a></div>
              -->
            </div>
          </section><!-- /.top-News -->
          <section class="top-News pt-0 pb-5">
            <div class="st-Grid_Inner1 st-Grid_Inner_appear p-0 pl-md-5">
              <h2 class="sw-Section_Header1" data-appear="true">
                <span class="sw-Section_Header-en"><b>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">PRODUCT SHOW</font>
                    </font>
                  </b></span>
                <span class="sw-Section_Header-ja"><b>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">精密部品展示</font>
                    </font>
                  </b></span>
              </h2>
              <div class="st-News_Slide swiper-container-news swiper-container-initialized swiper-container-horizontal appear" data-appear="true">
                <div class="swiper-wrapper">
                  <div v-for="(item, index) in newsData1" :key="index" class="swiper-slide swiper-slide-news">
                    <a :href="item.link" target="_blank">
                      <div class="st-News_Slide-image">
                        <div class="st-News_Slide-image-inner">
                          <div :style="{'background-image':item.imgSrc}"></div>
                        </div>
                      </div>
                      <div class="sw-Eyebrow">
                        <p class="sw-Eyebrow_Category">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;"></font>
                          </font>
                        </p>
                        <p class="sw-Eyebrow_Date">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit; background-color: #c7000b; color: white; padding:3px 6px">more......</font>
                          </font>
                        </p>
                      </div>
                      <p class="st-News_Slide-title">
                        <font style="vertical-align: inherit;">
                          <font style="vertical-align: inherit;">{{item.content1}}</font>
                        </font>
                      </p>
                    </a>
                  </div>
                </div>
                <div class="swiper-button-next"><i class="icf el-icon-arrow-right" style="font-size:25px;bottom: 15px;"></i></div>
                <div class="swiper-button-prev swiper-button-disabled"><i class="icf el-icon-arrow-left" style="font-size:25px;bottom: 15px;"></i></div>
                <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
              </div><!-- /.st-News_Slide -->
            </div>
          </section>
        </main><!-- /.st-MainContents -->
        <div class="st-Breadcrumbs">
          <ul class="st-BreadcrumbsList" itemscope="itemscope" itemtype="">
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <a class="st-BreadcrumbsList_Item-link" href="/" itemprop="item">ホーム</a>
              <meta itemprop="position" content="1">
            </li>
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <p itemprop="item" aria-current="page" style="margin-bottom: 0rem;"><span itemprop="name">精密平面研削</span></p>
              <meta itemprop="position" content="3">
            </li>
          </ul>
        </div>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'
import Swiper from 'swiper/swiper-bundle.js'
import 'swiper/swiper-bundle.css'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
      mySwiperNews: '',
      newsData: [
        { id: 1, lavel: '高度測定器', date: '2021.05.01', imgSrc: 'url(../../../../static/img/landing/main10.png)', content1: '瑞士 TRIMOS高度规', content2: 'TRIMOS Height Gauge' },
        { id: 2, lavel: '投影測定器', date: '2021.05.01', imgSrc: 'url(../../../../static/img/landing/main8.png)', content1: '萬濠光學投影機', content2: 'Rational Projector' },
        { id: 3, lavel: '2次元測定儀', date: '2021.05.01', imgSrc: 'url(../../../../static/img/landing/main1.png)', content1: '萬濠2.5次測量儀', content2: 'Rational 2.5 D Measuring Instrumen' },
        { id: 4, lavel: '比測儀', date: '2021.05.01', imgSrc: 'url(../../../../static/img/landing/main3.png)', content1: '尼康比測儀', content2: 'Nikon Hight Gauge' }
      ],
      newsData1: [
        { id: 1, imgSrc: 'url(../../../../static/img/landing/prod13.png)', content1: '超硬材料製品', link: 'http://www.simso-precision.com/ry/index.php?catid=9' },
        { id: 2, imgSrc: 'url(../../../../static/img/landing/prod3.png)', content1: '金属製品', link: 'http://www.simso-precision.com/ry/index.php?catid=11' },
        { id: 3, imgSrc: 'url(../../../../static/img/landing/prod1.png)', content1: '非金属製品', link: 'http://www.simso-precision.com/ry/index.php?catid=12' },
        { id: 4, imgSrc: 'url(../../../../static/img/landing/prod15.png)', content1: '特殊材料', link: 'http://www.simso-precision.com/ry/index.php?catid=13' },
        { id: 5, imgSrc: 'url(../../../../static/img/landing/prod16.png)', content1: '超高圧油圧関連製品', link: 'http://www.simso-precision.com/ry/index.php?catid=14' },
        { id: 6, imgSrc: 'url(../../../../static/img/landing/prod17.png)', content1: 'URACA高圧パンぷ', link: 'http://www.simso-precision.com/ry/index.php?catid=15' }
      ]
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      $('.series-PageTitle_Inner').eq(0).addClass('appear')
      let mySwiperNewsSettings = {
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
      this.mySwiperNews = new Swiper('.swiper-container-news', mySwiperNewsSettings)
      // element.offsetHeight
      let beforeScollH = 0
      $(document).scroll(() => {
        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        let homeH = $('.home')[0].offsetHeight
        let mql = window.matchMedia('(max-width:768px)')
        console.log(scroH)
        let differH = scroH - beforeScollH
        if (differH === 0) {
          return false
        }
        beforeScollH = scroH

        // console.log('type', beforeScollH, scroH, scollType)
        if (scroH > 50) {
          $('.st-Header').addClass('isStickyReverse')
          $('.series-Nav').addClass('series-Nav-display')
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.series-Nav').removeClass('series-Nav-display')
          $('.st-Header').removeClass('isStickyReverse')
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }
        if (differH > 0) {
          $('.series-Nav').removeClass('series-Nav-display')
          if (scroH > 50 && !$('.st-Hd_Trigger').hasClass('is-active')) {
            $('.st-Header').addClass('isStickyReverse')
            $('.header').css({'display': 'none'})
          }
          if (mql.matches) {
            $('.series-Nav').css({'padding-top': '0px'})
          }
        } else {
          $('.st-Header').removeClass('isStickyReverse')
          if (scroH > 50) {
            $('.series-Nav').addClass('series-Nav-display')
            if (mql.matches) {
              $('.series-Nav').css({'padding-top': '18px'})
            }
          } else {
            if (mql.matches) {
              $('.series-Nav').css({'padding-top': '0px'})
            }
          }
          $('.header').css({'display': 'block'})
        }
        if (viewW > 769) {
          if (scroH >= homeH - 2000) {
            $('.sw-Section_Header').eq(0).addClass('appear')
            $('.sw-Section_Header1').eq(0).addClass('appear')
            $('.swiper-container-news').addClass('appear')
            $('.st-Grid_Inner').eq(0).addClass('st-Grid_Inner_appear')
            $('.st-Grid_Inner1').eq(0).addClass('st-Grid_Inner_appear')
          } else {
            $('.sw-Section_Header').eq(0).removeClass('appear')
            $('.sw-Section_Header1').eq(0).removeClass('appear')
            $('.swiper-container-news').removeClass('appear')
            $('.st-Grid_Inner').eq(0).removeClass('st-Grid_Inner_appear')
            $('.st-Grid_Inner1').eq(0).removeClass('st-Grid_Inner_appear')
          }

          if (scroH >= 500) {
            $('.series-PageTitle_Inner').eq(0).removeClass('appear')
          } else {
            $('.series-PageTitle_Inner').eq(0).addClass('appear')
          }
          if (scroH >= 800) {
            $('.product-Detail_Lead').eq(0).removeClass('appear')
          } else {
            $('.product-Detail_Lead').eq(0).addClass('appear')
          }

          if (scroH >= 50 && scroH <= 1300) {
            $('.product-Detail_Column-image').eq(0).addClass('appear')
            $('.product-Detail_Column-text-appear').eq(0).addClass('appear')
          } else {
            $('.product-Detail_Column-image').eq(0).removeClass('appear')
            $('.product-Detail_Column-text-appear').eq(0).removeClass('appear')
          }

          if (scroH >= 500 && scroH <= 1800) {
            $('.product-Detail_Column-image').eq(1).addClass('appear')
            $('.product-Detail_Column-text-appear').eq(1).addClass('appear')
          } else {
            $('.product-Detail_Column-image').eq(1).removeClass('appear')
            $('.product-Detail_Column-text-appear').eq(1).removeClass('appear')
          }
        } else {
          $('.sw-Section_Header').eq(0).addClass('appear')
          $('.sw-Section_Header1').eq(0).addClass('appear')
          $('.swiper-container-news').addClass('appear')
          $('.st-Grid_Inner').eq(0).addClass('st-Grid_Inner_appear')
          $('.st-Grid_Inner1').eq(0).addClass('st-Grid_Inner_appear')
          $('.series-PageTitle_Inner').eq(0).addClass('appear')
          $('.product-Detail_Lead').eq(0).addClass('appear')
          $('.product-Detail_Column-image').eq(0).addClass('appear')
          $('.product-Detail_Column-text-appear').eq(0).addClass('appear')
          $('.product-Detail_Column-image').eq(1).addClass('appear')
          $('.product-Detail_Column-text-appear').eq(1).addClass('appear')
        }
      })
    }
  }
}
</script>
<style >
.isStickyReverse {
    -webkit-animation: stickyHide .2s forwards !important;
    animation: stickyHide .2s forwards !important;
}
  .series-Nav-display {
    transform: translateY(70px);
  }
</style>
<style scoped>
  .product-Detail_Column-image picture img {
    height: 390px;
    object-fit: cover
  }

  .sw-stickyTrigger-target {
    -webkit-transition: -webkit-transform .2s;
    transition: -webkit-transform .2s;
    -o-transition: transform .2s;
    transition: transform .2s;
    transition: transform .2s, -webkit-transform .2s;
    -webkit-box-shadow: 0 3px 10px 0 rgba(0, 0, 0, .1);
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, .1);
  }

  .home>>>.st-Header {
    -webkit-animation: stickyShow .2s forwards;
    animation: stickyShow .2s forwards;
  }

  .sw-ButtonRound a {
    padding: 18px 50px;
    min-width: 160px;
    background-color: #c7000b;
  }

  .sw-ButtonRound a span {
    margin-left: -25px
  }

  .sw-ButtonRound a span,
  .sw-ButtonRound a i {
    background-color: #c7000b;
    color: #FFFFFF;
  }

  .top-News .sw-Section_Header-en {
    font-size: 32px;
  }

  .top-News .sw-Section_Header-ja {
    font-size: 18px;
  }

  .st-Grid_Inner_appear:before {
    transform: scaleX(1) !important;
  }

  .st-Grid_Inner_appear:after {
    transform: scaleX(1) !important;
  }

  .st-Grid_Inner:before {
    content: "";
    width: 20vw;
    height: 5px;
    position: absolute;
    bottom: 0;
    transform: scale(1);
    transform: scaleX(0);
    -webkit-transition: -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    -o-transition: transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: transform 3s cubic-bezier(.23, 1, .32, 1), -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    transform-origin: left top;
    top: 81px;
  }

  .st-Grid_Inner:after {
    content: "";
    width: 100%;
    height: 3px;
    position: absolute;
    bottom: 0;
    transform: scale(1);
    background-color: #c7000b;
    transform: scaleX(0);
    -webkit-transition: -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    -o-transition: transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: transform 3s cubic-bezier(.23, 1, .32, 1), -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    transform-origin: left top;
    top: 83px;
  }

  .st-Grid_Inner1:before {
    content: "";
    width: 20vw;
    height: 5px;
    position: absolute;
    bottom: 0;
    transform: scale(1);
    transform: scaleX(0);
    -webkit-transition: -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    -o-transition: transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: transform 3s cubic-bezier(.23, 1, .32, 1), -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    transform-origin: left top;
    top: 81px;
  }

  .st-Grid_Inner1:after {
    content: "";
    width: 100%;
    height: 3px;
    position: absolute;
    bottom: 0;
    transform: scale(1);
    background-color: #c7000b;
    transform: scaleX(0);
    -webkit-transition: -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    -o-transition: transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: transform 3s cubic-bezier(.23, 1, .32, 1), -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    transform-origin: left top;
    top: 83px;
  }

  .swiper-slide-news {
    width: 360px !important;
    margin-right: 60px !important;
  }

  .swiper-button-next i:before,
  .swiper-button-prev i:before {
    font-size: 1.6rem;
    height: 25px;
    line-height: 25px;
    letter-spacing: 0;
    font-weight: bold;
  }

  @media screen and (min-width: 769px) {

    .st-News_Slide .swiper-button-next i:before,
    .st-News_Slide .swiper-button-prev i:before {
      font-size: 2.5rem;
      height: 25px;
      line-height: 25px;
      letter-spacing: 0;
      font-weight: bold;
    }
  }

  a {
    border-bottom-style: none;
  }

  .home>>>.st-Nav_List-en {
    color: #222;
  }

  .home>>>.st-Nav_List-ja {
    color: #222;
  }

  .home>>>.st-Header {
    background-color: #fff;
    border-bottom: 1px solid #ddd;

  }

  .home>>>.product font {
    color: #c7000b
  }

  .home>>>.product:after {
    transform: scaleX(1) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/product/product-0003.vue